'use strict';

angular.module('msActivityServices').service('librarySvc', ['httpSvc', function (httpSvc) {
  var cache;
  /**
   * Get the user's library
   * @param {boolean} clearCache if set to true, clear the cache and refresh the library from the server.
   * @return {object} Object which contains all the library objects, at the moment only the 'activities' array
   */
  function get(clearCache) {
    if (!cache || clearCache) {
      cache = httpSvc.get('/apiproxy/user/library');
    }
    return cache;
  }

  /**
   * Remove an activity from the library
   * @param  {string} shortName the activity to remove's url
   * @return {promise}          the http call promise
   */
  function removeActivity(url) {
    return httpSvc.delete('/apiproxy/user/library/activities/' + url);
  }

  /**
   * Add an activity to the user's library
   * @param {int} id the id of the activity to add
   */
  function addActivity(id) {
    return httpSvc.post('/apiproxy/user/library/activities/' + id, '');
  }

  /**
   * Add or remove an activity from the library. If it's in the library, remove it, if it's not, add it.
   * @param  {int}  id the activity to add or remove
   * @param  {boolean} true if it's already in the library, false if not
   */
  function toggleLibrary(id, inLibrary) {
    var fn = inLibrary ? removeActivity : addActivity;
    return fn(id).then(function (res) {
      // refresh the library from the server
      get(true);
      return res;
    });
  }

  /**
   * Determines if an activity is already in the library
   * @param  {strin} url the url to check
   * @return {boolean}         true if it's already in their library
   */
  function inLibrary(url) {
    return get().then(function (activities) {
      return activities.filter(function (activity) {
        return url === activity.url;
      }).length > 0;
    });
  }
  return {
    get: get,
    addActivity: addActivity,
    removeActivity: removeActivity,
    toggleLibrary: toggleLibrary,
    inLibrary: inLibrary
  };
}]);